import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, KeyRound, MessageCircle } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { useRates } from "@/context/RatesContext";

export default function AdminSettings() {
  const { settings, refresh } = useRates();
  const [whatsapp, setWhatsapp] = useState("");
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [next2, setNext2] = useState("");

  useEffect(() => {
    if (settings?.whatsapp_number) setWhatsapp(settings.whatsapp_number);
  }, [settings]);

  const saveSettings = async () => {
    try {
      await api.post("/admin/settings", { whatsapp_number: whatsapp.trim() });
      await refresh();
      toast.success("Settings saved");
    } catch (e) {
      toast.error(formatError(e?.response?.data?.detail) || "Failed");
    }
  };

  const changePassword = async () => {
    if (next !== next2) {
      toast.error("New passwords do not match");
      return;
    }
    if (next.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed");
      setCurrent(""); setNext(""); setNext2("");
    } catch (e) {
      toast.error(formatError(e?.response?.data?.detail) || "Failed");
    }
  };

  return (
    <div className="p-10 space-y-10 max-w-3xl">
      <div>
        <div className="ornament mb-2">Settings</div>
        <h1 className="font-display text-4xl text-ivory" style={{ fontWeight: 300 }}>Preferences</h1>
      </div>

      <section className="glass p-8 space-y-4">
        <div className="flex items-center gap-3 mb-2"><MessageCircle className="w-5 h-5 text-rose-gold" /><h2 className="font-display text-2xl text-ivory">WhatsApp Number</h2></div>
        <p className="text-ivory/50 text-sm">Customer enquiries will open a WhatsApp chat to this number.</p>
        <input value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} placeholder="919876543210" className="w-full bg-ink-900 border border-white/10 px-4 py-3 text-ivory focus:border-rose-gold" data-testid="whatsapp-input" />
        <button onClick={saveSettings} className="bg-rose-gold text-ink-900 px-5 py-3 font-medium tracking-widest uppercase text-sm flex items-center gap-2 hover:bg-champagne" data-testid="save-settings-button">
          <Save className="w-4 h-4" /> Save
        </button>
      </section>

      <section className="glass p-8 space-y-4">
        <div className="flex items-center gap-3 mb-2"><KeyRound className="w-5 h-5 text-rose-gold" /><h2 className="font-display text-2xl text-ivory">Change Password</h2></div>
        <input type="password" placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} className="w-full bg-ink-900 border border-white/10 px-4 py-3 text-ivory focus:border-rose-gold" data-testid="current-password" />
        <input type="password" placeholder="New password" value={next} onChange={(e) => setNext(e.target.value)} className="w-full bg-ink-900 border border-white/10 px-4 py-3 text-ivory focus:border-rose-gold" data-testid="new-password" />
        <input type="password" placeholder="Confirm new password" value={next2} onChange={(e) => setNext2(e.target.value)} className="w-full bg-ink-900 border border-white/10 px-4 py-3 text-ivory focus:border-rose-gold" data-testid="confirm-password" />
        <button onClick={changePassword} className="bg-rose-gold text-ink-900 px-5 py-3 font-medium tracking-widest uppercase text-sm flex items-center gap-2 hover:bg-champagne" data-testid="change-password-button">
          <Save className="w-4 h-4" /> Update Password
        </button>
      </section>
    </div>
  );
}
